export const getClonalityComparisonValue = (comparison) => {
  const rawValue = comparison?.attributes?.distance_metric_value;
  if (rawValue == null || rawValue === '') {
    return null;
  }

  const numericValue = Number(rawValue);
  return Number.isNaN(numericValue) ? null : numericValue;
};

export const isSuccessfulComputedClonalityComparison = (comparison) => (
  comparison?.attributes?.skip_reason == null
  && getClonalityComparisonValue(comparison) != null
);
